export interface ClaimFormValues {
	firstName: string;
	lastName: string;
}

export type ClaimFormErrors = Partial<Record<keyof ClaimFormValues, string>>;

const MAX_NAME_LENGTH = 50;

export const CLAIM_FORM_MESSAGES = {
	firstNameRequired: "First name is required",
	lastNameRequired: "Last name is required",
	firstNameTooLong: `First name cannot be more than ${MAX_NAME_LENGTH} characters`,
	lastNameTooLong: `Last name cannot be more than ${MAX_NAME_LENGTH} characters`
} as const;

/**
 * The offer email comes from the gift link and is shown read-only, so only the
 * two names are validated here.
 */
export function validateClaimForm(values: ClaimFormValues): ClaimFormErrors {
	const errors: ClaimFormErrors = {};
	const firstName = values.firstName.trim();
	const lastName = values.lastName.trim();

	if (!firstName) {
		errors.firstName = CLAIM_FORM_MESSAGES.firstNameRequired;
	} else if (firstName.length > MAX_NAME_LENGTH) {
		errors.firstName = CLAIM_FORM_MESSAGES.firstNameTooLong;
	}

	if (!lastName) {
		errors.lastName = CLAIM_FORM_MESSAGES.lastNameRequired;
	} else if (lastName.length > MAX_NAME_LENGTH) {
		errors.lastName = CLAIM_FORM_MESSAGES.lastNameTooLong;
	}

	return errors;
}

export function isClaimFormValid(errors: ClaimFormErrors): boolean {
	return Object.keys(errors).length === 0;
}
